// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#clear-data .warning-message {
  margin: 1rem 0 1rem;
  font-size: 1.5rem;
  color: var(--main-foreground-color);
}

#clear-data .warning-button {
  font-size: 1.8rem;
  margin: 0.5rem;
  color: white;
  border-radius: 999px;
  padding: 0.5rem 0.5rem;
  cursor: pointer;
}

#clear-data .delete {
  font-size: 1.5rem;
  background-color: var(--soft-red-color);
  border: 2px solid var(--soft-red-color);
}
`, "",{"version":3,"sources":["webpack://./src/components/ClearDataModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;EACvC,uCAAuC;AACzC","sourcesContent":["#clear-data .warning-message {\n  margin: 1rem 0 1rem;\n  font-size: 1.5rem;\n  color: var(--main-foreground-color);\n}\n\n#clear-data .warning-button {\n  font-size: 1.8rem;\n  margin: 0.5rem;\n  color: white;\n  border-radius: 999px;\n  padding: 0.5rem 0.5rem;\n  cursor: pointer;\n}\n\n#clear-data .delete {\n  font-size: 1.5rem;\n  background-color: var(--soft-red-color);\n  border: 2px solid var(--soft-red-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
